import React, { useContext, useEffect, useState } from 'react'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { SelectElement } from '../../../HtmlComponents/SelectElement'
import { InputImage } from '../../../HtmlComponents/InputImage'
import { hostName } from '../../../requestMethods'
import { FormDoctorContext } from '../types'
import { SexType, cabinetInterface } from '../../cabinets/types'
import { useSelector } from 'react-redux'
import { State } from '../../../redux/store'
import ReactSelect from 'react-select'

const InputsDoctor = () => {
  const {
    fullName, setFullName, yearOfBirth, setYearOfBirth, placeOfBirth, setPlaceOfBirth,
    sex, setSex, telephone, setTelephone, whatsapp, setWhatsapp, email, setEmail, current, setCurrent,
    origin, setOrigin, inscriptionDate, setInscriptionDate, avatar, setAvatar, password, setPassword,
    speciality, setSpeciality, cabinet, setCabinet, medecinType, setMedecinType
  } = useContext(FormDoctorContext)

  const { cabinets } = useSelector((state: State) => state.cabinets)

  const [listCabinet, setListCabinet] = useState<any[]>([])

  useEffect(() => {
    setListCabinet(cabinets.map((cliniq: cabinetInterface) => ({ value: cliniq._id, label: cliniq.name })))
  }, [cabinets])

  const { medecinTypes } = useSelector((state: State) => state.medecinType)

  const [MedecineTypeArr, setMedecineTypeArr] = useState<any[]>([])

  useEffect(() => {
    setMedecineTypeArr(medecinTypes.map((docType: any) => ({ _id: docType._id, name: docType.title })))
  }, [medecinTypes])

  return (     
    <div className="grid md:grid-cols-2 gap-2">
      <InputElement labelClass="text-main" name="Nom Complet" placeholder='Nom Complet' value={fullName} setValue={setFullName} />
      <InputElement labelClass="text-main" type="password" name="Mot de passe" placeholder='Mot de passe' value={password} setValue={setPassword} />
      <InputElement labelClass="text-main" type="number" name="Annee de naissance" placeholder='Annee de naissance' value={yearOfBirth} setValue={setYearOfBirth} />
      <InputElement labelClass="text-main" name="Lieu de naissance" placeholder='Lieu de naissance' value={placeOfBirth} setValue={setPlaceOfBirth} />
      <SelectElement labelClass="text-main" name="Sexe" options={SexType} defaultOption={<option>Choisir un sexe</option>} value={sex} setValue={setSex} />
      <InputElement labelClass="text-main" name="Telephone" placeholder='Telephone' value={telephone} setValue={setTelephone} />
      <InputElement labelClass="text-main" name="Whatsapp" placeholder='Whatsapp' value={whatsapp} setValue={setWhatsapp} />
      <InputElement labelClass="text-main" name="Email" placeholder='Email' value={email} setValue={setEmail} />
      {/* type="email" */}
      <div>
        <p className='font-bold text-main'>Nationnalité</p>
        <InputElement name="Actuelle" placeholder='Actuelle' value={current} setValue={setCurrent} />
        <InputElement name="Origine" placeholder='Origine' value={origin} setValue={setOrigin} />  
        <SelectElement name="Medecin" options={MedecineTypeArr} defaultOption={<option>Choisir type</option>} value={medecinType} setValue={setMedecinType} />
      </div>
      <InputElement labelClass="text-main" type="date" name="Date D'inscription" placeholder="Date D'inscription" value={inscriptionDate} setValue={setInscriptionDate} />
      <InputElement labelClass="text-main" name="Specialité" placeholder='Specialité' value={speciality} setValue={setSpeciality} />
      <div className='mb-2'>
        <label className='font-bold text-main' htmlFor="cabinet">Choisir un clinique</label>
        <ReactSelect id="cabinet" onChange={(e) => setCabinet(e)} value={cabinet} placeholder="Cabinets" options={listCabinet}/>
      </div>

      <InputImage  labelClass="text-main" name="Profile" setValue={setAvatar} />
      {/* image comes from db */}
      {(avatar && (typeof avatar === 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={hostName + "imgs/doctors/" + avatar} alt="avatar" /> 
      </div>}
      {/* image choosen from here */}
      {(avatar && (typeof avatar !== 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={URL.createObjectURL(avatar)} alt="avatar" /> 
      </div>}
      {/* {avatar && <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px", justifySelf: "end" }} src={URL.createObjectURL(avatar)} alt="avatar"/>} */}
    </div>
  )
}

export default InputsDoctor